import React from 'react';
// import Barcode from 'react-barcode';
import logo from '../../../images/r2s-logo.png';

const AnnualScores = ({ annualData }) => {
    const containerStyles = {
        display: 'block',
        border: '1px solid #000', // You can adjust the color and style as needed
        padding: '10px', // Optional: Add padding for better visualization
        lineHeight: '1.5',
        };

    const tableStyles = {
        backgroundColor: '#fff',
        width: '100%',
        borderCollapse: 'collapse',
        };

        const theadStyles = {
        border: '1px solid #111',
        backgroundColor: '#f2f2f2',
        };

        const cellStyles = {
        border: '1px solid #dee2e6',
        padding: '8px',
        textAlign: 'left',
        verticalAlign: 'middle',
    };
    // console.log(annualData);
    let slno =1;
    // Your conversion logic
    const convertedArray = annualData.reduce((result, entry) => {
        // Find existing entry based on student_uid, academic_year, and te
        const existingEntry = result.find(item => 
            item.student_uid === entry.student_uid &&
            item.academic_year === entry.academic_year &&
            item.te === entry.te
        );
    
        // If an existing entry is found, add the score details to its scores array
        if (existingEntry) {
            existingEntry.scores.push({
                subject_name: entry.subject_name,
                subject_code: entry.subject_code,
                score: entry.score
            });
        } else {
            // If no existing entry is found, create a new entry with scores array
            const newEntry = {
                // student_name: entry.student_name.split(' ')[0], // Extract first name
                student_name: entry.student_name,
                student_uid: entry.student_uid,
                academic_year: entry.academic_year,
                te: entry.te,
                scores: [
                    {
                        subject_name: entry.subject_name,
                        subject_code: entry.subject_code,
                        score: entry.score
                    }
                ]
            };
            result.push(newEntry);
        }
    
        return result;
    }, []);

    if (convertedArray.length === 0) {
        return <p>No data available.</p>;
    }

    return (
        <div>
        <>
            <div style={containerStyles}>
                    <div style={{display:'flex', justifyContent:'space-between'}}>
                        <div className="p-1" style={{alignItems:'left'}}>
                            <h1 className="text-white">
                            <img src={logo} width="100" alt='logo'/>
                            </h1>
                        </div>
                        <div className="p-1" style={{textAlign:'right'}}>
                            <div className="text-black">
                            THE GROWING TREE MONTESORRY SCHOOL<br />
                            PILLANGKATTA, RI-BHOI, MEGHALAYA - 793101<br />
                            Phone No: +91 97066-12141 <br />
                            Email: tgt2023@gmail.com
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div style={{display:'flex', justifyContent:'center', padding:'4px'}}>
                        <table className="table-bordered" style={tableStyles}>
                            <thead style={theadStyles}>
                                <tr>
                                    <th style={cellStyles}>Name</th>
                                    <th style={cellStyles}>UID</th>
                                    <th style={cellStyles}>Academic Year</th>
                                    <th style={cellStyles}>Assessment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {convertedArray.map((entry, index) => (
                                    <tr key={index}>
                                        <td style={cellStyles}>{entry.student_name}</td>
                                        <td style={cellStyles}>{entry.student_uid}</td>
                                        <td style={cellStyles}>{entry.academic_year}</td>
                                        <td style={cellStyles}>{entry.te}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <div>
                        <h3>Details</h3>
                        <br />
                        <table className="table-bordered" style={tableStyles}>
                            <thead style={theadStyles}>
                                <tr>
                                    <th style={cellStyles}>Sl.No.</th>
                                    <th style={cellStyles}>FM</th>
                                    <th style={cellStyles}>PM</th>
                                    <th style={cellStyles}>Subject</th>
                                    <th style={cellStyles}>Marks Obtained</th>
                                </tr>
                            </thead>
                            <tbody>
                                {convertedArray.map((entry, index) => (
                                <tr key={index}>
                                    <td style={cellStyles}>{entry.scores.map((score, scoreIndex) => (
                                                <div key={scoreIndex}>
                                                    {slno ++}
                                                </div>
                                            ))}
                                        </td>
                                        <td style={cellStyles}>{entry.scores.map((score, scoreIndex) => (
                                                <div key={scoreIndex}>
                                                    100
                                                </div>
                                            ))}
                                        </td>
                                        <td style={cellStyles}>{entry.scores.map((score, scoreIndex) => (
                                                <div key={scoreIndex}>
                                                    33
                                                </div>
                                            ))}
                                        </td>
                                        <td style={cellStyles}>{entry.scores.map((score, scoreIndex) => (
                                                <div key={scoreIndex}>
                                                    {score.subject_name}
                                                </div>
                                            ))}
                                        </td>
                                        <td style={cellStyles}>
                                            {entry.scores.map((score, scoreIndex) => (
                                                <div key={scoreIndex}>
                                                    {score.score}
                                                </div>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <div className="body-section">
                        <p>&copy; Recode Technologies. All rights reserved. 
                            <a href="https://www.recodetechnologies.in" className="float-right">www.recodetechnologies.in</a>
                        </p>
                    </div>      
                </div>
            </>
        </div>
    )
}

export default AnnualScores
